import styled from 'styled-components'

import { mediaQueries } from '@fourthwall/components'

export const Form = styled.form`
  display: grid;
  gap: 24px;

  ${mediaQueries.tablet} {
    grid-template-columns: repeat(2, 1fr);
    align-items: start;
  }
`

export const FiltersColumn = styled.div`
  display: grid;
  gap: 20px;
`

export const CheckboxGroup = styled.div`
  display: grid;
  gap: 12px;
`
